import { gql } from "@apollo/client";

// `getEventsForCompany` was removed — use server-side `events` or
// other queries instead. This export intentionally removed because
// the codebase no longer uses `GET_EVENTS_FOR_COMPANY`.

export const GET_PLATFORM_EVENTS = gql`
  query myPlatformEvents(
    $platformEventType: String!
    $isLeagueRequest: Boolean!
  ) {
    myPlatformEvents(
      platformEventType: $platformEventType
      isLeagueRequest: $isLeagueRequest
    )
  }
`;

export const GET_EVENT = gql`
  query getEvent($eventID: String!) {
    getEvent(data: { slug: $eventID, eventType: PLATFORM_EVENT })
  }
`;

export const GET_PLATFORM_EVENT_MEMBERS = gql`
  query getPlatformEventMembers($id: String!) {
    getPlatformEventMembers(data: { id: $id, eventType: PLATFORM_EVENT })
  }
`;

export const GET_PLATFORM_FAMILY_MEMBERS = gql`
  query familyMembersAttendingEvent($userID: String!, $eventID: String!) {
    familyMembersAttendingEvent(data: { userID: $userID, eventID: $eventID })
  }
`;

export const GET_ALL_EVENT_CONTENTS = gql`
  query getAllEventContents($eventId: String!) {
    getAllEventContents(data: { eventId: $eventId })
  }
`;

export const GET_ALL_EVENT_TRANSACTION_HISTORY = gql`
  query getAllEventTransactionHistory($eventId: String!, $forUser: Boolean) {
    getAllEventTransactionHistory(
      data: { eventId: $eventId, forUser: $forUser }
    )
  }
`;

export const GET_EVENT_CART_ITEM = gql`
  query getEventCartItem($eventId: String!) {
    getEventCartItem(data: { eventId: $eventId })
  }
`;

export const GET_SQUAD_BUILDER_DATA = gql`
  query GetSquadBuilderData($data: GetSquadBuilderDataInput!) {
    getSquadBuilderData(data: $data)
  }
`;

export const GET_LINKED_LEAGUE_EVENT_ID = gql`
  query getLinkedLeagueEventId($clubEventId: String!) {
    getLinkedLeagueEventId(clubEventId: $clubEventId)
  }
`;

export const GET_CLUB_LEAGUE_CREDIT_OPTIONS = gql`
  query getClubLeagueCreditOptions($clubEventId: String!) {
    getClubLeagueCreditOptions(clubEventId: $clubEventId)
  }
`;

export const GET_TEAM_LEAGUE_SUBMISSION = gql`
  query getTeamLeagueSubmission(
    $clubEventId: String!
    $leagueEventId: String!
    $teamName: String!
  ) {
    getTeamLeagueSubmission(
      clubEventId: $clubEventId
      leagueEventId: $leagueEventId
      teamName: $teamName
    )
  }
`;

export const GET_EVENT_CLUSTERS = gql`
  query getEventClusters($eventId: String!) {
    getEventClusters(data: { eventId: $eventId })
  }
`;

export const COMPANY_EMPLOYEES_ATTENDING_EVENT = gql`
  query companyEmployeesAttendingEvent($eventId: String!) {
    companyEmployeesAttendingEvent(data: { eventID: $eventId })
  }
`;

export const CHECK_EVENT_ATTENDANCE = gql`
  query checkEventAttendance($eventID: String!) {
    checkEventAttendance(data: { eventID: $eventID, eventType: PLATFORM_EVENT })
  }
`;

export const GET_REQUEST_TO_JOIN_EVENT_LIST = gql`
  query getRequestToJoinEventList($eventId: String!) {
    getRequestToJoinEventList(data: { eventId: $eventId })
  }
`;

export const GET_REQUEST_TO_JOIN = gql`
  query getRequestToJoin($eventId: String!) {
    getRequestToJoin(data: { eventId: $eventId })
  }
`;

export const GET_BILLING_COUPON_INFO_BY_PROMO_CODE = gql`
  query getBillingCouponInfoByPromoCode(
    $promoCode: String!
    $channel: String!
  ) {
    getBillingCouponInfoByPromoCode(promoCode: $promoCode, channel: $channel)
  }
`;

export const CHECK_EVENT_ATTENDANCE_BY_USER = gql`
  query checkEventAttendanceByUser($eventID: String!) {
    checkEventAttendance(data: { eventID: $eventID, eventType: PLATFORM_EVENT })
  }
`;

export const GET_ALL_KEYWORD_CATEGORIES = gql`
  query GetAllKeywordCategories(
    $keywordType: String
    $companyId: String
    $sport: String
  ) {
    getAllKeywordCategories(
      keywordType: $keywordType
      companyId: $companyId
      sport: $sport
    )
  }
`;

export const GET_EVENT_QR_PREFERENCES = gql`
  query GetEventQrPreferences($eventId: ID!) {
    getEventQrPreferences(eventId: $eventId) {
      first_checked
      last_checked
      avatar_checked
      company_checked
      job_title_checked
      age_checked
      member_id_checked
      location_checked
      gender_checked
      email_checked
      mobile_checked
      phone_checked
      dob_checked
      salutation_checked
      region_checked
      country_checked
      city_checked
      postcode_checked
      address_checked
      addressTwo_checked
      bio_checked
      categorisedKeywords_checked
      clusterKeywords_checked
      keywords_checked
      locale_checked
      facebook_checked
      instagram_checked
      linkedIn_checked
      twitter_checked
      weChat_checked
      weibo_checked
      qq_checked
      skype_checked
      socialLine_checked
      nationalSecurityNumber_checked
      passportNumber_checked
    }
  }
`;

export const GET_CONTENT_CLUSTER_RECIPIENTS = gql`
  query GetContentClusterRecipients($data: GetContentClusterRecipientsInput!) {
    getContentClusterRecipients(data: $data)
  }
`;

export const GET_CONTENT_CLUSTER_RESPONSES = gql`
  query GetContentClusterResponses($data: GetContentClusterResponsesInput!) {
    getContentClusterResponses(data: $data)
  }
`;

export const GET_EVENT_INVITATION = gql`
  query getEventInvitation($invitationID: String!) {
    getEventInvitation(invitationID: $invitationID)
  }
`;

export const GET_LEAGUE_INVITATION_BY_TOKEN = gql`
  query getLeagueInvitationByToken($token: String!) {
    getLeagueInvitationByToken(token: $token)
  }
`;

export const GET_MY_LEAGUE_CLUB_STATUS = gql`
  query getMyLeagueClubStatus($eventId: String!) {
    getMyLeagueClubStatus(eventId: $eventId)
  }
`;

export const MY_COMPANIES = gql`
  query myCompanies($companyType: Float, $excludeCompanyType: Float) {
    myCompanies(
      companyType: $companyType
      excludeCompanyType: $excludeCompanyType
    )
  }
`;

export const EMPLOYEES_IN_COMPANY = gql`
  query employeesInCompany($data: GetEmployeesInput!) {
    employeesInCompany(data: $data)
  }
`;

export const GET_LEAGUE_ALLOCATION = gql`
  query getLeagueAllocation($data: GetLeagueAllocationInput!) {
    getLeagueAllocation(data: $data)
  }
`;

export const GET_LEAGUE_FIXTURES = gql`
  query getLeagueFixtures($data: GetLeagueFixturesInput!) {
    getLeagueFixtures(data: $data)
  }
`;

export const GET_CLUB_LEAGUE_FIXTURES = gql`
  query getClubLeagueFixtures($leagueEventId: String!, $clubEventId: String) {
    getClubLeagueFixtures(
      leagueEventId: $leagueEventId
      clubEventId: $clubEventId
    )
  }
`;

export const GET_POSTCODE_COORDINATES = gql`
  query getPostcodeCoordinates($postcodes: [String!]!) {
    getPostcodeCoordinates(postcodes: $postcodes)
  }
`;
